import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface CheckWasDeleteRequestedResponse extends BackendResponse {
  item: Date;
}

export const checkWasDeleteRequested =
  withNextApi<CheckWasDeleteRequestedResponse>(
    "/cvp/CvpWasDeleteRequested",
    { method: "GET" }
  );
